/**
 * 화면 언어 식별자의 정본은 화면 언어 결정 기록이다. 지원 목록의 정본이 이 상수 하나이고
 * Backend는 선호값을 받는 자리에서 자기 목록으로 다시 검증한다. 신뢰 경계가 Backend라
 * 목록을 양쪽이 갖는다.
 */
export const LANGUAGE_IDS = ['ko', 'en', 'ja'] as const

export type LanguageId = (typeof LANGUAGE_IDS)[number]

/**
 * 문구가 비어 나갈 때 내려가는 자리. 한국어가 문구의 소스라 여기는 한국어다.
 *
 * 협상이 걸리지 않을 때 내려가는 자리와 다른 일이다. 한 상수로 두면 다음에 둘을 함께
 * 움직이게 된다.
 */
export const SOURCE_LANGUAGE: LanguageId = 'ko'

/**
 * 브라우저가 우리가 여는 셋을 하나도 말하지 않을 때 그리는 언어.
 *
 * 한국어가 문구의 소스라는 사실과 그 사람에게 무엇을 보일지는 다른 문제다. 셋 중 어느 것도
 * 말하지 않는 브라우저를 쓰는 사람이 한국어를 읽을 까닭이 없고, 그 자리에서 영어가 읽힐
 * 가능성이 가장 크다.
 */
export const FALLBACK_LANGUAGE: LanguageId = 'en'

/**
 * 목록에 서는 이름은 언제나 그 언어의 자기 이름이다. 고르는 사람은 지금 화면을 읽지 못해서
 * 고르므로 읽지 못하는 언어로 적은 이름은 아무것도 알려 주지 않는다. 세 항목이 어느 화면
 * 언어에서나 같은 글자로 서서 자리와 순서도 흔들리지 않는다.
 */
export const LANGUAGE_NAMES: Record<LanguageId, string> = {
  ko: '한국어',
  en: 'English',
  ja: '日本語',
}

/**
 * 표기 로케일 태그. 날짜 순서와 12시간 표기 같은 관습이 지역에서 갈리므로 지역을 뗀 태그를
 * 쓰지 않는다.
 */
export const LOCALE_TAGS: Record<LanguageId, string> = {
  ko: 'ko-KR',
  en: 'en-US',
  ja: 'ja-JP',
}

export interface LanguagePreference {
  /** 없음은 고른 값을 비운다는 뜻이다. 그 뒤로는 브라우저가 말하는 언어를 따른다. */
  languageId: LanguageId | null
}

export function isLanguageId(value: unknown): value is LanguageId {
  return typeof value === 'string' && (LANGUAGE_IDS as readonly string[]).includes(value)
}
